import { FC, useRef, useEffect, useState, PropsWithChildren } from 'react'
import { shallowEqual, useSelector, connect, useDispatch, ConnectedProps } from 'react-redux'
import { LayoutSplashScreen } from '../../../../_template/layout/core'
import * as auth from './AuthRedux'
import { getUserByToken, refresh, logout } from './AuthCRUD'
import { RootState } from '../../../../setup'
import { AuthModel } from '../models/AuthModel'
import { Redirect, Switch } from 'react-router-dom'
import * as cookieManager from '../../../../setup/redux/CookieManager'

const mapState = (state: RootState) => ({ auth: state.auth })
const connector = connect(mapState, auth.actions)
type PropsFromRedux = ConnectedProps<typeof connector>

const AuthInit: FC<PropsWithChildren<PropsFromRedux>> = (props) => {
  const didRequest = useRef(false)
  const dispatch = useDispatch()
  const [showSplashScreen, setShowSplashScreen] = useState(true)
  const [gotoLogin, setGotoLogin] = useState(false)
  const accessToken = useSelector<RootState>(({ auth }) => auth.accessToken, shallowEqual) as AuthModel
  let tokenExpireFunc = setTimeout(() => { }, 5000);

  // We should request user by authToken before rendering the application
  useEffect(() => {
    const refreshToken = async () => {
      const accTkn = cookieManager.getCookie("access_token") ? JSON.parse(cookieManager.getCookie("access_token")!) : undefined;
      if (!accTkn) return;

      let timeDiff = (new Date(accTkn.expire_in).getTime() - new Date().getTime()) - (10 * 1000);
      clearTimeout(tokenExpireFunc);
      if (timeDiff > 0) {
        tokenExpireFunc = setTimeout(async () => {
          const { data: token } = await refresh();
          if (token.status) {
            dispatch(props.refreshToken(token.data))
            refreshToken();
          }
        }, timeDiff);
      }
    }

    const requestUser = async () => {
      try {
        if (!didRequest.current) {
          const { data: user } = await getUserByToken()
          if (user.status) {
            await refreshToken();
            dispatch(props.fulfillUser(user.data))
          } else {
            throw new Error(user.message);
          }
        }
      } catch (error) {
        console.error(error)
        if (!didRequest.current) {
          await logout();
          dispatch(props.logout())
          setGotoLogin(true)
          window.location.reload()
        }
      } finally {
        setShowSplashScreen(false)
      }

      return () => (didRequest.current = true)
    }

    tokenExpireFunc = setInterval(refreshToken, 5000)
    if (accessToken && accessToken.token_policy == "webuser") {
      requestUser()
    } else {
      dispatch(props.logout())
      setShowSplashScreen(false)
    }
    // eslint-disable-next-line
  }, [])

  return gotoLogin ? (<Switch> <Redirect to='/auth/login' /></Switch>) : showSplashScreen ? <LayoutSplashScreen /> : <>{props.children}</>
}

export default connector(AuthInit)
